import Chevron from '../../dashboard/components/navigationMenu/components/chevron';
import { useTranslation } from 'react-i18next';
import React, { useEffect, useRef, useState } from 'react';

import './accordion.scss';

interface IArgs {
    title: string;
    content: any;
    icon?: string;
    isError?: boolean;
    isOpen?: boolean;
    onToggle?: () => void;
}

const Accordion = ({
    title,
    content,
    icon,
    isError,
    isOpen,
    onToggle,
}: IArgs) => {
    const { t } = useTranslation();
    const [setActive, setActiveState] = useState<string>('');
    const [setHeight, setHeightState] = useState<string>('0px');
    const [setRotate, setRotateState] = useState<string>('accordion__icon');
    const element: any = useRef(null);
    const isControlled = isOpen !== undefined;
    let errorClass = '';
    let errorContentClass = '';
    let chevronColor = '#777';
    if (isError) {
        errorClass = 'accordion__error';
        errorContentClass = 'accordion__error error__content';
        chevronColor = '#fff';
    }

    useEffect(() => {
        if (isControlled) {
            setActiveState(isOpen ? 'active' : '');
            setHeightState(
                isOpen ? `${element.current?.scrollHeight}px` : '0px',
            );
            setRotateState(
                isOpen ? 'accordion__icon rotate' : 'accordion__icon',
            );
        }
    }, [isOpen, isControlled]);

    function toggleAccordion() {
        if (onToggle) {
            onToggle();
            return;
        }
        setActiveState(setActive === '' ? 'active' : '');
        setHeightState(
            setActive === 'active'
                ? '0px'
                : `${element.current?.scrollHeight}px`,
        );
        setRotateState(
            setActive === 'active'
                ? 'accordion__icon'
                : 'accordion__icon rotate',
        );
    }
    return (
        <div className={`accordion__section ${errorClass}`}>
            <div
                className={`accordion ${setActive} ${errorClass}`}
                onClick={toggleAccordion}
            >
                <a className={`accordion__title ${errorClass}`}>
                    {icon && (
                        <i
                            className={`c-icon-list__icon c-icon c-icon--[${icon}]`}
                            aria-hidden='true'
                            role='img'
                        />
                    )}
                    {t(title)}
                </a>
                <span>
                    <Chevron
                        className={`${setRotate}`}
                        width={10}
                        fill={chevronColor}
                    />
                </span>
            </div>
            <div
                ref={element}
                style={{ maxHeight: `${setHeight}` }}
                className={`accordion__content ${errorContentClass}`}
            >
                <div className='accordion__text'>{content}</div>
            </div>
        </div>
    );
};

export default Accordion;
